import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import Num2persian from 'num2persian';


@Component({
  selector: 'app-site-material-list-print',
  templateUrl: './site-material-list-print.component.html',
  styleUrls: ['./site-material-list-print.component.scss']
})
export class SiteMaterialListPrintComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  lang: any = 1;
  user_id: number | undefined;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  public reception_id: number | undefined;
  public code: number | undefined;
  id: number;
  list_material: any = [];
  list_cate: any = [];
  list_cate2: any = [];
  list_logo2: any = [];
  seleton_id: number | undefined;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , public activatedRoute: ActivatedRoute) { }//end consructor

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.reception_id = params['id'];
        this.code = params['token'];
      }
    )
    this.get_reception();
  }

  get_reception() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = { address: 10590, id: this.reception_id, code: this.code }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.id = res['result'][0].site_ckd_id;
          this.seleton_id = res['result'][0].site_ckd_seleton_id;
          this.get_material();
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_material() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10592, ckd_id: this.id, seleton_id: this.seleton_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            var x = (this.list_cate.findIndex((index: any) => index.wharehouse_material_cate_id == res['result'][i].wharehouse_material_cate_id));
            if (x == -1) {
              this.list_cate.push(res['result'][i]);
            }
            var xx = (this.list_cate2.findIndex((index: any) => index.wharehouse_material_cate2_id == res['result'][i].wharehouse_material_cate2_id));
            if (xx == -1) {
              res['result'][i]
              this.list_cate2.push(res['result'][i]);
            }

            if (res['result'][i].wharehouse_material_logo) res['result'][i].logo = res['result'][i].wharehouse_material_site + "/" + res['result'][i].wharehouse_material_logo;
            this.list_material.push(res['result'][i]);
            if (res['result'][i].wharehouse_material_logo2) {
              res['result'][i].logo2 = res['result'][i].wharehouse_material_site + "/" + res['result'][i].wharehouse_material_logo2;
              this.list_logo2.push({ logo2: res['result'][i].logo2, cate: res['result'][i].wharehouse_material_cate_id })
            }
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 5000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}